import { usePostHttp } from "../../http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  id: string;
}

interface IOtpResponse extends IOtp {}

export function useEphemeralResendOtpCommonHttp() {
  return usePostHttp<IBody, IOtpResponse>({
    path: "/common/users/authentication/resend-otp",
  });
}
